module.exports = __webpack_public_path__ + "img/kb-image.jpg";